<template>
  <div class="dashboar-wrapper">
    <div class="row">
      <div class="col-md-12 dashboard">dashboard
        <div class="icon-information"></div>
      </div>
    </div>
    <div class="row margin-bottom-8px">
      <div class="col-md-12">
        <div class="plan">Plan</div>
        <div class="event-status">event status</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-1">
        <div class="text">Drafts</div>
        <div class="numbers">{{drafts}}</div>
      </div>
      <div class="col-md-1">
        <div class="text">Submitted</div>
        <div class="numbers">{{submitted}}</div>
      </div>
      <div class="col-md-1">
        <div class="text">Review</div>
        <div class="numbers">{{review}}</div>
      </div>
      <div class="col-md-1">
        <div class="text">Approved</div>
        <div class="numbers">{{approved}}</div>
      </div>
      <div class="col-md-1">
        <div class="text">Archived</div>
        <div class="numbers">{{archived}}</div>
      </div>
      <div class="col-md-7"></div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="divider"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="plan">Manage</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="event-cards-container">
          <div v-if="events.length === 0" class="text">No approved events</div>
          <EventCard v-else :key="index" :isChangeOrder="isChangeOrder" :event="event" v-for="(event, index) in events" :isNoTrans="index % 3 == 2" :isFromClientDashboardView="true"></EventCard>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="divider"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="plan">Sign ups</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="graph">Graph 1</div>
        <div class="graph">Graph 2</div>
        <div class="graph">Graph 3</div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  import constants from '../../../_consts';
  import EventCard from '../../eventManagement/manage/EventCard';

  import Icon from 'vue-awesome/components/Icon';

  import 'vue-awesome/icons/file-excel-o';
  import 'vue-awesome/icons/question-circle-o';
  import 'vue-awesome/icons/sort-down';
  import 'vue-awesome/icons/users';

  export default {
    name: 'c-dashboard-clien-view',
    components: {
      Icon,
      EventCard
    },
    props: {},
    data () {
      return {
        isChangeOrder: false,
        events: {},
        drafts: 0,
        submitted: 0,
        review: 0,
        approved: 0,
        archived: 0
      };
    },
    computed: {
      ...mapGetters({})
    },
    methods: {
      getAllData (eventId) {
        // reset count in case nothing is returned
        this.drafts = 0;
        this.submitted = 0;
        this.review = 0;
        this.approved = 0;
        this.archived = 0;
        let clientId = localStorage.getItem(constants.LOCAL_STORE.clientId);
        this.getEventCount({ clientId }).then(response => {
          let total = response.countTotalEventsByClient[0].countEventsByStatus;
          total.forEach(tol => {
            if (tol.status === 'DRAFTS') {
              this.drafts = tol.countTotal;
            } else if (tol.status === 'SUBMITTED') {
              this.submitted = tol.countTotal;
            } else if (tol.status === 'REVIEW') {
              this.review = tol.countTotal;
            } else if (tol.status === 'APPROVED') {
              this.approved = tol.countTotal;
            } else if (tol.status === 'ARCHIVED') {
              this.archived = tol.countTotal;
            }
          });
        });
        let body = {
          clientId: clientId,
          status: 'APPROVED'
        };
        this.getApprovedEventsByStatus(body).then(response => {
          this.events = response.events;
          if (eventId) {
            this.$modal.show('eventDetailModal', eventId);
          }
        });
      },
      ...mapActions({
        getEventCount: 'ACTION_GET_EVENT_COUNT_BY_CLIENT_NEW',
        getApprovedEventsByStatus: 'ACTION_GET_EVENT_BY_STATUS',
        getClientConfigMessage: 'ACTION_GET_MESSAGE_MODAL'
      })
    },
    beforeMount () {
    },
    mounted: function () {
      this.isChangeOrder = localStorage.getItem(constants.LOCAL_STORE.role) === 'CLIENT';
      this.getAllData();
      this.getClientConfigMessage();
    },
    created () {
      this.$bus.$on('resetGetData', this.getAllData);
    },
    watch: {}
  };
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .dashboar-wrapper {
    padding: 24px 16px 24px 16px;
    .dashboard {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 32px;
      font-weight: 800;
      letter-spacing: -1px;
      line-height: 40px;
      text-transform: uppercase;
    }
    .plan {
      color: @black-1;
      font-family: @font-family-main;
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
      margin-top: 32px;
    }
    .event-status {
      color: @black-1;
      font-family: @font-family-main;
      font-size: 12px;
      letter-spacing: 0.1px;
      line-height: 16px;
      text-transform: uppercase;
      margin-top: 16px;
    }
    .icon-information {
      display: inline-block;
      margin: 0 8px;
      width: 24px;
      height: 24px;
      color: @grey-3;
      background-color: @light-blue;
      -webkit-mask: url('../../../../static/img/status-information.svg') no-repeat center;
      mask: url('../../../../static/img/status-information.svg') no-repeat center;
      background: url('../../../../static/img/status-information-blue.svg');
    }
    .text {
      color: @black-2;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
    }
    .numbers {
      color: @black-1;
      font-family: @font-family-main;
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
    }
    .divider {
      box-sizing: border-box;
      height: 2px;
      border: 1px solid @grey-4;
      margin-top: 35px;
    }
    .graph {
      margin-top: 20px;
      height: 277px;
      width: 270px;
      display: inline-block;
      border-radius: 4px;
      background-color: @white;
      box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 1px rgba(0, 0, 0, 0.1);
      margin-right: 24px;
    }
    .event-cards-container {
      margin: 24px -12px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;

      .event-card-container{
        margin: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?55ebfcd6